export default "---\n\n---\n\n"